import { Component } from 'react';
import getConfig from 'next/config';
import { flowRight as compose } from 'lodash';
import { withRouting, withRoutingPropType } from '../../hocs/withRouting';
import { withActiveLocale } from '../../hocs/withActiveLocale';


const {
  publicRuntimeConfig: { AUTH_HUB_URL, LODGELINK_REDIRECT_URL }
} = getConfig();

/**
 * When this componnet is rendered on a page it will redirect the user to the
 * SignIn page.
 *
 * The "redirect" parameter will be automatically set so that after logging in
 * the user can be redirected back to the page they started on.
 */
class RedirectSignIn extends Component {

  constructor(props) {
    super(props);

    if (process.browser) {
      const {
        router: { asPath }
      } = props;

      const fullReturnUrl = `${LODGELINK_REDIRECT_URL}${asPath}`;
      const redirectParam = `/login?returnTo=${encodeURIComponent(fullReturnUrl)}`;
      const finalUrl = `${AUTH_HUB_URL}${redirectParam}`;

      // Use window.location for external redirect
      window.location.href = finalUrl;
    }
  }

  render() {
    return null;
  }
}

RedirectSignIn.propTypes = {
  router: withRoutingPropType.isRequired
};

const RedirectSignInComponent = compose(
  withRouting,
  withActiveLocale
)(RedirectSignIn);

export default RedirectSignInComponent;


